import { FileEntity } from 'api/types/entity';

/**
 * Enum representing different file types.
 */
export enum FileExtension {
  pdf,
  csv,
  png,
}

interface Accept {
  [key: string]: string[];
}

export const FILE_ACCEPT_TYPES: Record<FileExtension, Accept> = {
  [FileExtension.pdf]: { 'application/pdf': ['.pdf'] },
  [FileExtension.csv]: { 'text/csv': ['.csv'] },
  [FileExtension.png]: { 'image/png': ['.png'] },
};

export interface LocalFileEntity extends Omit<FileEntity, 'id'> {
  id?: string;
}
